import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import TableCard from "../../components/TableCard";
import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";
import BlueButton from "../../components/BlueButton";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import WhiteButton from "../../components/WhiteButton";
import CheckIcon from "@mui/icons-material/Check";
import SendIcon from "@mui/icons-material/Send";
import { keyframes } from "@emotion/react";
import styles from "./styles.module.css";
import dayjs from "dayjs";
import InputAdornment from "@mui/material/InputAdornment";
import CalculateIcon from "@mui/icons-material/Calculate";
import ToolBar from "../../components/ToolBar";
import ExportExcelButton from "../../components/ExportExcelButton";
import SnackBar from "../../components/SnackBar";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fab,
  Grid,
  TextField,
} from "@mui/material";
import {
  obterBasesCalculo,
  obterBasesCalculoPorCampoDeBusca,
  cadastrarBasesCalculo,
  atualizarBasesCalculo,
  excluirBasesCalculo,
} from "../../services/api-esocial.service";
import GenericDatePickerReference from "../../components/GenericDatePickerReference";
import { debounce } from "lodash";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import { exportExcel } from "../../utils/exportExcelFunction";

const BasesCalculo = ({ data }) => {
  const [dataTable, setDataTable] = useState([]);
  const [loading, setLoading] = useState(false);
  const [idBaseCalculo, setIdBaseCalculo] = useState(null);
  const [idGrupoEconomico, setIdGrupoEconomico] = useState(null);
  const [idEmpresa, setIdEmpresa] = useState(null);
  const [valorDiferencaBase, setValorDiferencaBase] = useState(30360);
  const [taxa20s, setTaxa20s] = useState(Number(5.8));
  const [isEdit, setIsEdit] = useState(false);
  const [openModalInsert, setOpenModalInsert] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [referencia, setReferencia] = useState("");
  const [valor, setValor] = useState({ content: "0", error: false });
  const [objSnackBar, setObjSnackBar] = useState({ type: "", msg: "" });
  const [exportdata, setExportData] = useState([]);

  const columns = [
    "Referência",
    "Base de Cálculo",
    "Diferença Base",
    "Cálculo 20S",
    "Taxa Selic",
    "Acréscimo Selic",
    "Valor Atualizado",
  ];

  const handleAtualizaDados = async () => {
    try {
      setLoading(true);
      const response = await obterBasesCalculo(
        data ? data.idEmpresa : idEmpresa
      );
      const responseOrganizada = handleOrganizaData(response.basesCalculo);
      setDataTable(responseOrganizada);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setObjSnackBar({ type: "error", msg: "Erro ao obter Bases Cálculo!" });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await obterBasesCalculo(
          data ? data.idEmpresa : idEmpresa
        );
        const responseOrganizada = handleOrganizaData(response.basesCalculo);
        setDataTable(responseOrganizada);
      } catch (error) {
        setDataTable([]);
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    if (idEmpresa || data) {
      fetchData();
    } else {
      setDataTable([]);
    }
  }, [idEmpresa]);

  const handleOpenModalInsert = async () => {
    setOpenModalInsert(true);
  };

  const handleOpenModalDelete = async () => {
    setOpenModalDelete(true);
  };

  const handleCloseModalInsert = () => {
    setOpenModalInsert(false);
    setIdBaseCalculo(null);
    setReferencia({ content: null, error: false });
    setValor({ content: "0", error: false });
  };

  const handleCloseModalDelete = () => {
    setOpenModalDelete(false);
  };

  const formatCurrency = (value) => {
    if (!value || isNaN(value)) return "R$ 0,00";
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
    }).format(value);
  };

  const formatPercentage = (value) => {
    if (value == null) return "";
    return String(value).replace(".", ",");
  };

  const addTableCellValues = (basesCalculo) => {
    return basesCalculo.map((base) => {
      base.referencia_cellval =
        base.referencia.split("-")[1] + "/" + base.referencia.split("-")[0];
      base.valor = parseFloat(base.valor);
      base.valor_cellval = parseFloat(base.valor);

      base.diferencaBase =
        parseFloat(base.valor) - parseFloat(valorDiferencaBase) > 0
          ? parseFloat(base.valor) - parseFloat(valorDiferencaBase)
          : 0;
      base.diferencaBase_cellVal = base.diferencaBase;

      base.calculo20s =
        parseFloat((base.diferencaBase * taxa20s) / 100) > 0
          ? parseFloat((base.diferencaBase * taxa20s) / 100)
          : 0;
      base.calculo20s_cellVal = parseFloat(base.calculo20s);

      base.taxaSelic_cellVal = base.taxaSelic
        ? parseFloat(base.taxaSelic)
        : "0.00";

      base.acrescimo_selic =
        parseFloat(base.calculo20s) * base.taxaSelic > 0
          ? (parseFloat(base.calculo20s) * base.taxaSelic) / 100
          : 0;

      base.acrescimo_selic_cellVal = !base.taxaSelic
        ? ""
        : base.acrescimo_selic
        ? base.acrescimo_selic
        : "0.00";

      base.valor_atualizado =
        base.calculo20s + base.acrescimo_selic > 0
          ? parseFloat(base.calculo20s + base.acrescimo_selic)
          : 0;

      base.valor_atualizado_cellVal = !base.taxaSelic
        ? ""
        : parseFloat(base.valor_atualizado)
        ? parseFloat(base.valor_atualizado)
        : "0.00";

      return base;
    });
  };

  const handleOrganizaData = (dados) => {
    return addTableCellValues(dados).map((item) => {
      return {
        data: dayjs(item.referencia).format("MM/YYYY"),
        valor: formatCurrency(item.valor),
        diferencaBase: formatCurrency(item.diferencaBase),
        calculo20s: formatCurrency(item.calculo20s),
        taxaSelic: item.taxaSelic ? `${item.taxaSelic}%` : "0%",
        acrescimoSelic: formatCurrency(item.acrescimo_selic),
        valorAtualizado: formatCurrency(item.valor_atualizado),
        botoes: [
          {
            icon: <EditIcon />,
            title: "EDITAR",
            onClick: async () => {
              try {
                setIsEdit(true);
                setIdBaseCalculo(item.idBaseCalculo);
                setReferencia(item.referencia);
                setValor({ content: item.valor, error: false });
                handleOpenModalInsert();
              } catch (error) {
                console.log(error);
              }
            },
          },
          {
            icon: <DeleteForeverIcon />,
            title: "EXCLUIR",
            onClick: () => {
              setIdBaseCalculo(item.idBaseCalculo);
              handleOpenModalDelete();
            },
          },
        ],
      };
    });
  };

  const handleDebounce = debounce((value) => {
    handlePesquisaPorTexto(value);
  }, 500);

  const handlePesquisaPorTexto = async (value) => {
    if (value === "") {
      handleAtualizaDados();
      return;
    }

    try {
      setLoading(true);

      const formattedValue = value.replace("%", "").replace(",", ".");

      const response = await obterBasesCalculoPorCampoDeBusca(
        data ? data.idEmpresa : idEmpresa,
        formattedValue
      );

      setDataTable(handleOrganizaData(response.basesCalculo));
    } catch (error) {
      if (error.response?.status === 404) {
        setDataTable([]);
      } else {
        setObjSnackBar(
          error.response?.data?.mensagem || {
            type: "error",
            msg: "Erro ao preparar dados para exportação.",
          }
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitInsert = async (e) => {
    e.preventDefault();
    setLoading(true);

    const objInsert = {
      baseCalculo: {
        referencia: dayjs(referencia.content).format("YYYY-MM"),
        valor: valor.content || "0",
      },
    };

    try {
      const response = await cadastrarBasesCalculo(
        data ? data.idEmpresa : idEmpresa,
        objInsert
      );
      setLoading(false);
      setObjSnackBar({ type: "success", msg: "Salvo com sucesso!" });
      handleCloseModalInsert();
      handleAtualizaDados();
    } catch (error) {
      setLoading(false);
      setObjSnackBar({ type: "error", msg: "Erro ao criar Base Cálculo!" });
    }
  };

  const handleSubmitUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);

    const objUpdate = {
      baseCalculo: {
        referencia: dayjs(referencia).format("YYYY-MM"),
        valor: valor.content || "0",
      },
    };

    try {
      const response = await atualizarBasesCalculo(
        data ? data.idEmpresa : idEmpresa,
        idBaseCalculo,
        objUpdate
      );
      setLoading(false);
      setObjSnackBar({ type: "success", msg: "Atualizado com sucesso!" });
      handleCloseModalInsert();
      handleAtualizaDados();
    } catch (error) {
      setLoading(false);
      setObjSnackBar({ type: "error", msg: "Erro ao tentar atualizar!" });
    }
  };

  const handleSubmitDelete = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await excluirBasesCalculo(
        data ? data.idEmpresa : idEmpresa,
        idBaseCalculo
      );
      setLoading(false);
      setObjSnackBar({ type: "success", msg: "Excluído com sucesso!" });
      handleCloseModalDelete();
      handleAtualizaDados();
    } catch (error) {
      setLoading(false);
      setObjSnackBar({ type: "error", msg: "Erro ao tentar excluir!" });
    }
  };

  const pulse = keyframes`
      0% {
          transform: scale(1);
      }
      50% {
          transform: scale(1.1);
      }
      100% {
          transform: scale(1);
      }`;

  const handleChangeValue = (name, value) => {
    switch (name) {
      case "referencia":
        if (!isNaN(value.getTime())) {
          setReferencia({
            content: value,
            error: value != null ? false : true,
          });
        } else {
          setReferencia({
            content: value,
            error: true,
          });
        }
        break;
      case "valor":
        setValor({ content: value, error: value != null ? false : true });
        break;
    }
  };

  const handleChangeReferencia = (newValue) => {
    setReferencia({ content: newValue, error: false });
  };

  const handleBuscaEmpresas = (obj) => {
    setIdGrupoEconomico(parseInt(obj.GE?.id));
    setIdEmpresa(parseInt(obj.CNPJ?.id));
  };

  const handleExportToExcel = async () => {
    try {
      if (!Array.isArray(dataTable) || dataTable.length === 0) {
        setObjSnackBar({ type: "error", msg: "Não há dados para exportar!" });
        return [[], ""];
      }

      const formattedData = dataTable.map((item) => ({
        Referência: item.dataTable,
        "Base de Cálculo": item.valor,
        "Diferença Base": item.diferencaBase,
        "Cálculo 20S": item.calculo20s,
        "Taxa Selic": parseFloat(item.taxaSelic.replace("%", "")),
        "Acréscimo Selic": item.acrescimoSelic,
        "Valor Atualizado": item.valorAtualizado,
      }));

      const totalRow = {
        Referência: "Total",
        "Base de Cálculo": formattedData.reduce(
          (sum, row) =>
            sum +
            parseFloat(
              row["Base de Cálculo"].replace(/[^0-9,-]/g, "").replace(",", ".")
            ),
          0
        ),
        "Diferença Base": formattedData.reduce(
          (sum, row) =>
            sum +
            parseFloat(
              row["Diferença Base"].replace(/[^0-9,-]/g, "").replace(",", ".")
            ),
          0
        ),
        "Cálculo 20S": formattedData.reduce(
          (sum, row) =>
            sum +
            parseFloat(
              row["Cálculo 20S"].replace(/[^0-9,-]/g, "").replace(",", ".")
            ),
          0
        ),
        "Taxa Selic": formattedData.reduce(
          (sum, row) => sum + row["Taxa Selic"],
          0
        ),
        "Acréscimo Selic": formattedData.reduce(
          (sum, row) =>
            sum +
            parseFloat(
              row["Acréscimo Selic"].replace(/[^0-9,-]/g, "").replace(",", ".")
            ),
          0
        ),
        "Valor Atualizado": formattedData.reduce(
          (sum, row) =>
            sum +
            parseFloat(
              row["Valor Atualizado"].replace(/[^0-9,-]/g, "").replace(",", ".")
            ),
          0
        ),
      };

      const valoresBaseRow = {
        Referência: "Valores Base",
        "Base de Cálculo": 0,
        "Diferença Base": 30360,
        "Cálculo 20S": 0.058,
        "Taxa Selic": null,
        "Acréscimo Selic": 0,
        "Valor Atualizado": 0,
      };

      formattedData.push({});
      formattedData.push(totalRow);
      formattedData.push({});
      formattedData.push(valoresBaseRow);

      setObjSnackBar({
        type: "success",
        msg: "Arquivo Excel gerado com sucesso!",
      });

      return [formattedData, "bases_calculo"];
    } catch (error) {
      console.error("Erro ao preparar dados para exportação:", error);
      setObjSnackBar({
        type: "error",
        msg: "Erro ao preparar dados para exportação.",
      });
      setExportData([]);
      return [[], ""];
    }
  };

  const handleFunctionExportExcel = async () => {
    try {

      const formattedData = dataTable.map((item) => ({
        Referência: item.dataTable,
        "Base de Cálculo": item.valor,
        "Diferença Base": item.diferencaBase,
        "Cálculo 20S": item.calculo20s,
        "Taxa Selic": parseFloat(item.taxaSelic.replace("%", "")),
        "Acréscimo Selic": item.acrescimoSelic,
        "Valor Atualizado": item.valorAtualizado,
      }));

      const totalRow = {
        Referência: "Total",
        "Base de Cálculo": formattedData.reduce(
          (sum, row) =>
            sum +
            parseFloat(
              row["Base de Cálculo"].replace(/[^0-9,-]/g, "").replace(",", ".")
            ),
          0
        ),
        "Diferença Base": formattedData.reduce(
          (sum, row) =>
            sum +
            parseFloat(
              row["Diferença Base"].replace(/[^0-9,-]/g, "").replace(",", ".")
            ),
          0
        ),
        "Cálculo 20S": formattedData.reduce(
          (sum, row) =>
            sum +
            parseFloat(
              row["Cálculo 20S"].replace(/[^0-9,-]/g, "").replace(",", ".")
            ),
          0
        ),
        "Taxa Selic": formattedData.reduce(
          (sum, row) => sum + row["Taxa Selic"],
          0
        ),
        "Acréscimo Selic": formattedData.reduce(
          (sum, row) =>
            sum +
            parseFloat(
              row["Acréscimo Selic"].replace(/[^0-9,-]/g, "").replace(",", ".")
            ),
          0
        ),
        "Valor Atualizado": formattedData.reduce(
          (sum, row) =>
            sum +
            parseFloat(
              row["Valor Atualizado"].replace(/[^0-9,-]/g, "").replace(",", ".")
            ),
          0
        ),
      };

      const valoresBaseRow = {
        Referência: "Valores Base",
        "Base de Cálculo": 0,
        "Diferença Base": 30360,
        "Cálculo 20S": 0.058,
        "Taxa Selic": null,
        "Acréscimo Selic": 0,
        "Valor Atualizado": 0,
      };

      formattedData.push({});
      formattedData.push(totalRow);
      formattedData.push({});
      formattedData.push(valoresBaseRow);

      console.log(formattedData);
      
      await exportExcel([formattedData, "bases_calculo"]);
    } catch (error) {
      setObjSnackBar({ type: "error", msg: error });
    }
  };

  const btnHoverAddFab = [
    {
      icon: <DownloadRoundedIcon />,
      label: "Exportar Relatório",
      onClick: () => handleFunctionExportExcel(),
    },
  ];

  return (
    <>
      {!data ? (
        <ToolBar>
          <div className={styles.actions__bar}>
            <div className={styles.filterData__bar}>
              <TextField
                error={valorDiferencaBase.error}
                value={formatCurrency(valorDiferencaBase)}
                onChange={(event) =>
                  handleChangeValue("valor", event.target.value)
                }
                fullWidth
                size="small"
                label="Valor Diferença Base"
              />

              <TextField
                error={taxa20s.error}
                value={formatPercentage(taxa20s)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">%</InputAdornment>
                  ),
                }}
                onChange={(event) =>
                  handleChangeValue("taxa20s ", event.target.value)
                }
                fullWidth
                size="small"
                label="Taxa 20S"
              />
            </div>
            <div className={styles.extrator__bar}>
              <ExportExcelButton
                className={styles.botaoNovo}
                retrieveData={handleExportToExcel} // Passa a função de exportação
                buttonLabel="Exportar Excel"
                onError={(message) => {}}
              />
            </div>
          </div>
        </ToolBar>
      ) : (
        ""
      )}
      <div>
        <TableCard
          iconHeader={<CalculateIcon fontSize="1rem" />}
          titleHeader="Cálculo 20S"
          data={dataTable}
          setData={setDataTable}
          columns={columns}
          loading={loading}
          handleDebounce={handleDebounce}
          handleGrupoEmpresa={data ? null : handleBuscaEmpresas}
          hasEmpresa={data ? false : true}
          uniqueEmpresa
          hoverBtnHeader={data ? btnHoverAddFab : null}
        />
        {idEmpresa ? (
          <Fab
            sx={{
              background: "#4b6fc0",
              bottom: 40,
              right: 20,
              position: "fixed",
              zIndex: 1000,
              animation: `${pulse} 1.5s infinite ease-in-out`,
              "&:hover": {
                backgroundColor: "#fff",
              },
            }}
            aria-label="add"
            onClick={() => {
              setIsEdit(false);
              handleOpenModalInsert();
            }}
          >
            <AddIcon className={styles.iconeAdd} />
          </Fab>
        ) : (
          ""
        )}
        <Dialog
          fullWidth
          open={openModalInsert}
          onClose={handleCloseModalInsert}
        >
          <DialogTitle>
            <h4>{isEdit ? "Atualizar" : "Inserir"} Base de Cálculo</h4>
          </DialogTitle>
          <DialogContent>
            <form onSubmit={isEdit ? handleSubmitUpdate : handleSubmitInsert}>
              <Grid container spacing={2} sx={{ marginBottom: "1rem" }}>
                {!isEdit && (
                  <>
                    <Grid item xs={12} sm={6}>
                      <GenericDatePickerReference
                        label={"Referência"}
                        value={referencia.content}
                        onChange={handleChangeReferencia}
                        sx={{ marginTop: "1rem" }}
                      />
                    </Grid>
                  </>
                )}
                {isEdit && (
                  <Grid item xs={12} sm={6}>
                    <GenericDatePickerReference
                      label={`Referência`}
                      value={referencia}
                      onChange={(value) =>
                        setReferencia(dayjs(value).format("YYYY-MM"))
                      }
                      sx={{ marginTop: "1rem" }}
                    />
                  </Grid>
                )}
                <Grid item xs={12} sm={6}>
                  <TextField
                    error={valor.error}
                    value={valor.content}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">R$</InputAdornment>
                      ),
                    }}
                    onChange={(event) =>
                      handleChangeValue("valor", event.target.value)
                    }
                    fullWidth
                    size="small"
                    label="Base de Cálculo"
                    sx={{ marginTop: "1rem" }}
                  />
                </Grid>
              </Grid>
              <DialogActions
                sx={{
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <WhiteButton
                  clickFunction={handleCloseModalInsert}
                  textValue="Fechar"
                  contentIcon={<CloseIcon />}
                  iconLeft
                />

                <BlueButton
                  textValue="Salvar"
                  type="submit"
                  contentIcon={<SendIcon />}
                />
              </DialogActions>
            </form>
          </DialogContent>
        </Dialog>
        <Dialog open={openModalDelete} onClose={handleCloseModalDelete}>
          <DialogContent>
            <h2 style={{ fontSize: "1.1rem" }}>
              Deseja mesmo excluir essa Base de Cálculo?
            </h2>
            <div className={styles.containerButtons}>
              <WhiteButton
                textValue="Não"
                contentIcon={<CloseIcon />}
                clickFunction={handleCloseModalDelete}
                iconLeft
              />
              <BlueButton
                textValue="Sim"
                contentIcon={<CheckIcon />}
                clickFunction={handleSubmitDelete}
              />
            </div>
          </DialogContent>
        </Dialog>
      </div>
      <SnackBar objSnackBar={objSnackBar} setObjSnackBar={setObjSnackBar} />
    </>
  );
};

export default BasesCalculo;
